import Modal from "app/components/Modal/Modal";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import "./TwoFactorAuthModal.scss";

type props = {
  isOpen: boolean;
  onClose: () => void;
  onVerify2fa: (code: string) => void;
};

// Shows a modal with input and button
//  to allow user to enter code for login
const TwoFactorAuthModal: React.FC<props> = ({
  isOpen,
  onClose,
  onVerify2fa,
}) => {
  const intl = useIntl();
  const [authCode, setAuthCode] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);
    onVerify2fa(authCode);
  };
  useEffect(() => {
    setIsSubmitDisabled(authCode.length < 6);
  }, [authCode]);

  useEffect(() => {
    if (!isOpen) {
      setAuthCode("");
      setIsSubmitting(false);
    }
  }, [isOpen]);
  const handleClose = () => {
    // Do nothing - user must enter valid code
  };

  return (
    <Modal
      modalOpen={isOpen}
      closeModal={handleClose}
      contentLabel="Two-Factor Authentication"
      className="auth-screen__password-modal"
      underlayClickExits={false}
      escapeExits={false}
      cancelButton={false}
    >
      <div className="two-factor-login-modal">
        <h1 className="two-factor-login-modal__heading">
          <FormattedMessage id="login-2fa-heading" />
        </h1>
        <form onSubmit={handleSubmit}>
          <div className="text-input">
            <input
              type="text"
              className="two-factor-login-modal__input"
              value={authCode}
              onChange={e => {
                setError("");
                const value = e.target.value;
                if (value === "" || /^\d+$/.test(value)) {
                  // Only allows numbers or empty string
                  setAuthCode(value);
                }
              }}
              placeholder={intl.formatMessage({
                id: "2fa-verify-code-error",
                defaultMessage: "Please enter a 6-digit code",
              })}
              disabled={isSubmitting}
            />
          </div>

          {error && (
            <div className="two-factor-login-modal__error-msg">{error}</div>
          )}

          <div className="two-factor-login-modal__message">
            <FormattedMessage id="login-2fa-instruction" />
          </div>

          <button
            type="submit"
            className="two-factor-login-modal__submit"
            disabled={isSubmitDisabled || isSubmitting}
          >
            {isSubmitting ? (
              <FormattedMessage id="login-2fa-verifying" />
            ) : (
              <FormattedMessage id="login-2fa-verify-button" />
            )}
          </button>
        </form>
      </div>
    </Modal>
  );
};

export default TwoFactorAuthModal;
